import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetPlanReviewCandidatesResolutionMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input'];
  resolution: Types.Scalars['String']['input'];
}>;


export type SetPlanReviewCandidatesResolutionMutation = { __typename?: 'mutation_root', update_plan_review_requirement_candidates?: { __typename?: 'plan_review_requirement_candidates_mutation_response', affected_rows: number } | null };


export const SetPlanReviewCandidatesResolutionDocument = gql`
    mutation setPlanReviewCandidatesResolution($ids: [uuid!]!, $resolution: String!) {
  update_plan_review_requirement_candidates(
    where: {id: {_in: $ids}}
    _set: {resolution: $resolution}
  ) {
    affected_rows
  }
}
    `;
export type SetPlanReviewCandidatesResolutionMutationFn = Apollo.MutationFunction<SetPlanReviewCandidatesResolutionMutation, SetPlanReviewCandidatesResolutionMutationVariables>;

/**
 * __useSetPlanReviewCandidatesResolutionMutation__
 *
 * To run a mutation, you first call `useSetPlanReviewCandidatesResolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPlanReviewCandidatesResolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPlanReviewCandidatesResolutionMutation, { data, loading, error }] = useSetPlanReviewCandidatesResolutionMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      resolution: // value for 'resolution'
 *   },
 * });
 */
export function useSetPlanReviewCandidatesResolutionMutation(baseOptions?: Apollo.MutationHookOptions<SetPlanReviewCandidatesResolutionMutation, SetPlanReviewCandidatesResolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPlanReviewCandidatesResolutionMutation, SetPlanReviewCandidatesResolutionMutationVariables>(SetPlanReviewCandidatesResolutionDocument, options);
      }
export type SetPlanReviewCandidatesResolutionMutationHookResult = ReturnType<typeof useSetPlanReviewCandidatesResolutionMutation>;
export type SetPlanReviewCandidatesResolutionMutationResult = Apollo.MutationResult<SetPlanReviewCandidatesResolutionMutation>;
export type SetPlanReviewCandidatesResolutionMutationOptions = Apollo.BaseMutationOptions<SetPlanReviewCandidatesResolutionMutation, SetPlanReviewCandidatesResolutionMutationVariables>;